import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import "hammerjs";
import {NgxImageCompressService} from 'ngx-image-compress';

import { FuseModule } from "@fuse/fuse.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { SDKBrowserModule } from "@lbsdk/*";

import { fuseConfig } from "./fuse-config";

import { AppComponent } from "./app.component";
import { FuseMainModule } from "./main/main.module";
import { FuseSampleModule } from "./main/content/sample/sample.module";
import { LoginModule } from "@app/auth/login/login.module";
import { MaterialModule } from "@app/material/material.module";
import { GameModule } from "@app/main/content/game/game.module";
import { GameSettingsModule } from "@app/main/content/game-settings/game-settings.module";
import { AuthModule } from "@app/auth/auth.module";
import { PushNotificationsModule } from "@app/main/content/push-notifications/push-notifications.module";
import { ConfirmationDialogComponent } from "@app/main/content/confirmation-dialog/confirmation-dialog.component";

const appRoutes: Routes = [
  {
    path: "privacy-policy",
    loadChildren:
      "./main/content/privacy-policy/privacy-policy.module#PrivacyPolicyModule",
  },
  {
    path: "dashboard",
    loadChildren: "./main/content/game/game.module#GameModule",
  },
  {
    path: "send-message",
    loadChildren:
      "./main/content/push-notifications/push-notifications.module#PushNotificationsModule",
  },
  {
    path: "settings",
    loadChildren: "./main/main.module#FuseMainModule",
  },
  {
    path: "inquires",
    loadChildren: "./main/content/inquiry/inquiry.module#InquiryModule",
  },
  {
    path: "statistics",
    loadChildren:
      "./main/content/statistics/statistics.module#StatisticsModule",
  },
  {
    path: "games/new",
    loadChildren: "./main/main.module#FuseMainModule",
  },
  {
    path: "sample",
    loadChildren: "./main/content/sample/sample.module#FuseSampleModule",
  },
  {
    path: "auth",
    loadChildren: "./auth/auth.module#AuthModule",
  },
  {
    path: "",
    loadChildren:
      "./main/content/coming-soon/coming-soon.module#ComingSoonModule",
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  declarations: [
    AppComponent,
    ConfirmationDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    TranslateModule.forRoot(),
    SDKBrowserModule.forRoot(),

    // Fuse Main and Shared modules
    FuseModule.forRoot(fuseConfig),
    FuseSharedModule,
    FuseMainModule,
    FuseSampleModule,

    // angular material library module
    MaterialModule,

    // login Module
    LoginModule,

    // Game Module
    GameModule,
    GameSettingsModule,
    PushNotificationsModule,

    AuthModule,
  ],
  exports: [BrowserModule],
  providers: [NgxImageCompressService],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent],
})
export class AppModule {}
